import { TabContext } from './tab.types';

export function isMatch(context: TabContext, pattern: string[]): boolean {
  const path = context.path;

  if (path.length !== pattern.length) return false;

  for (let i = 0; i < pattern.length; i++) {
    const patternSegment = pattern[i];
    const pathSegment = path[i];

    const isDynamicSegment = patternSegment.startsWith(':');
    if (isDynamicSegment) {
      if (!pathSegment || pathSegment.length === 0) return false;
      continue;
    }

    if (patternSegment !== pathSegment) return false;
  }

  return true;
}

export function deserialize(path: string): TabContext {
  if (!path)
    return {
      path: ['home'],
      params: {},
    };

  try {
    const url = new URL(path, 'https://example.com');
    let route = url.pathname.split('/').filter(Boolean);

    // /workspace/ 프리픽스 제거
    if (route[0] === 'workspace') {
      route = route.slice(1);
    }

    const params = Object.fromEntries(url.searchParams.entries());
    const tabId: string | undefined = params.tabId;
    delete params.tabId;

    return { path: route, params, tabId };
  } catch {
    return {
      path: ['home'],
      params: {},
    };
  }
}

export function serialize(context: TabContext): string {
  const path = '/workspace/' + context.path.join('/');
  const url = new URL(path, 'https://example.com');
  url.searchParams.set('tabId', context.tabId || '');
  Object.entries(context.params).forEach(([key, value]) => {
    url.searchParams.set(key, value?.toString() || '');
  });

  return url.toString().replace('https://example.com', '');
}
